import {ChartType, SPECIAL_EVENTS} from 'common/report/constants';
import {FormulaClause} from 'common/report/insights/models/formula-clause';
import {FormulaSection} from 'common/report/insights/models/section';
import {ChartPlotStyle} from 'common/report/insights/util/types';
import {Report} from 'common/report/insights/models/report';

import {Formula, formulaClauseToFormula, formulaToFormulaClause} from './types';

/**
 * Transforms formulas to FormulaSection
 */
export function getFormulaSection(formulas: Formula[]): FormulaSection {
  const clauses = formulas.map(formulaToFormulaClause);

  return FormulaSection.create(FormulaSection.TYPE, clauses);
}

/**
 * Transforms FormulaSection clauses to formulas
 */
export function getFormulas(formulaClauses: FormulaClause[]): Formula[] {
  return formulaClauses.map(formulaClauseToFormula);
}

export function getFormulaDisabledReason(report: Report) {
  const {displayOptions, sections} = report;

  if (report.isEmpty()) {
    return `To add a formula, you must select an event first`;
  }

  if (displayOptions && displayOptions.chartType === ChartType.Pie) {
    return `Formulas is not available when using pie chart`;
  }

  if (sections.show.getBehaviorClauses().some((c) => c.behavior.name === SPECIAL_EVENTS.TOP_EVENTS)) {
    return `To add a formula, select something other than "Your Top Events"`;
  }

  if (displayOptions && displayOptions.plotStyle === ChartPlotStyle.Stacked) {
    return `Formulas is not available when using stacked chart`;
  }

  return ``;
}
